import { render, staticRenderFns } from "./FormRenderer.vue?vue&type=template&id=413fc444"
import script from "./FormRenderer.vue?vue&type=script&lang=js"
export * from "./FormRenderer.vue?vue&type=script&lang=js"
import style0 from "./FormRenderer.vue?vue&type=style&index=0&id=413fc444&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports